import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error in component:', error, errorInfo);
  }

  private handleReload = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="min-h-[200px] p-6 m-4 bg-mystic-900/90 border border-gold-500/40 rounded-2xl text-center flex flex-col items-center justify-center backdrop-blur-md shadow-2xl">
          <div className="w-12 h-12 rounded-full bg-gold-500/20 border border-gold-400 flex items-center justify-center text-2xl mb-3">
            
          </div>
          <h3 className="text-lg font-serif font-bold text-white mb-1">
            Une mise à jour cosmique est en cours
          </h3>
          <p className="text-xs text-gray-300 max-w-md mb-3">
            Un élément a été rechargé. Cliquez sur le bouton ci-dessous pour actualiser l'affichage.
          </p>
          {this.state.error && (
            <div className="mb-4 p-3 bg-red-950/80 border border-red-500/50 rounded-xl text-left max-w-lg w-full text-xs font-mono text-red-200 overflow-auto max-h-32 select-text">
              <strong>Détail de l'erreur :</strong> {this.state.error.toString()}
            </div>
          )}
          <button
            onClick={this.handleReload}
            className="px-4 py-2 bg-gradient-to-r from-gold-600 to-yellow-500 hover:from-gold-500 hover:to-yellow-400 text-black font-bold rounded-xl text-xs uppercase tracking-wider transition-all transform hover:scale-105 shadow-lg"
          >
            Actualiser l'élément
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
